import { ThumbDown, ThumbDownOffAlt, ThumbUp, ThumbUpOffAlt } from "@mui/icons-material";
import { IconButton } from "@mui/material";

type Props = {
    feedbackRating?: boolean | null;
    onChange(value: boolean | null): void;
};

export default function FeedbackIcon({ feedbackRating, onChange }: Props) {
    return (
        <div>
            <IconButton onClick={() => onChange(feedbackRating ? null : true)}>
                {feedbackRating ? <ThumbUp /> : <ThumbUpOffAlt />}
            </IconButton>
            <IconButton onClick={() => onChange(feedbackRating === false ? null : false)}>
                {feedbackRating == null || feedbackRating ? <ThumbDownOffAlt /> : <ThumbDown />}
            </IconButton>
        </div>
    );
}
